import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { getTranslatedMarbleColor } from 'src/services/i18n/utils/gameTranslations'

type Props = Readonly<{
  marbleColor: string
}>

export function IrlOddsValue({ marbleColor }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const translatedColor = getTranslatedMarbleColor(marbleColor, t)

  return <span className="marble-odds-value">{translatedColor}</span>
}
